export class RandomImage {
  constructor(container) {
    this.container = container;
    if (this.container === null) {
      return;
    }
    this.images = container.querySelectorAll('[data-random-image-item]');
    this.class = 'u-d-none';
    this.init();
  }

  init() {
    const random = Math.floor(Math.random() * this.images.length);
    this.images[random].classList.remove(this.class);
  }

}
document.addEventListener("DOMContentLoaded", function() {
  const containers = document.querySelectorAll('[data-random-image]');
  containers.forEach((container) => {
    new RandomImage(container);
  });
});
